"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataDepth = exports.generateMap = exports.cloneDeep = exports.checkSelectStatus = exports.getStatusOfCheck = exports.getStatusOfCheckUsingKeys = void 0;
var tslib_1 = require("tslib");
var getStatusOfCheckUsingKeys = function (dataSource, selectedRowKeys, indeterminateRowKeys) {
    var numberOfChecked = 0;
    var numberOfIndeterminate = 0;
    var numberOfActiveItem = 0;
    dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (item) {
        var key = item.key, disabled = item.disabled;
        var checked = selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys.includes(key);
        !disabled && numberOfActiveItem++;
        if (checked) {
            numberOfChecked++;
        }
        else {
            var indeterminate = indeterminateRowKeys === null || indeterminateRowKeys === void 0 ? void 0 : indeterminateRowKeys.includes(key);
            !checked && indeterminate && numberOfIndeterminate++;
        }
    });
    return {
        numberOfChecked: numberOfChecked,
        numberOfIndeterminate: numberOfIndeterminate,
        isCheckedAll: numberOfChecked === numberOfActiveItem && numberOfChecked > 0,
        indeterminateAll: numberOfChecked !== numberOfActiveItem && (numberOfChecked > 0 || numberOfIndeterminate > 0),
        numberOfActiveItem: numberOfActiveItem,
    };
};
exports.getStatusOfCheckUsingKeys = getStatusOfCheckUsingKeys;
var getStatusOfCheck = function (dataSource) {
    var numberOfChecked = 0;
    var numberOfIndeterminate = 0;
    var numberOfActiveItem = 0;
    dataSource.map(function (item) {
        var isSelected = item.isSelected, indeterminate = item.indeterminate, disabled = item.disabled;
        isSelected && numberOfChecked++;
        !disabled && numberOfActiveItem++;
        !isSelected && indeterminate && numberOfIndeterminate++;
    });
    return {
        // children中选中的数量
        numberOfChecked: numberOfChecked,
        // children中半选中的数量
        numberOfIndeterminate: numberOfIndeterminate,
        // children中可操作的数量
        numberOfActiveItem: numberOfActiveItem,
    };
};
exports.getStatusOfCheck = getStatusOfCheck;
var checkSelectStatus = function (dataSource, selectedKeys) {
    dataSource.forEach(function (item, index) {
        var key = item.key, children = item.children;
        // 深度优先遍历根据selectedkeys生成标志位isSelected/indeterminate.
        if (children) {
            (0, exports.checkSelectStatus)(children, selectedKeys);
            var _a = (0, exports.getStatusOfCheck)(children), numberOfChecked = _a.numberOfChecked, numberOfIndeterminate = _a.numberOfIndeterminate, numberOfActiveItem = _a.numberOfActiveItem;
            // 是否选中：selectedKeys.includes(key) || 可操作数 === 选中数就是有children情况下的选中
            dataSource[index].isSelected =
                selectedKeys.includes(key) ||
                    (numberOfActiveItem === numberOfChecked && numberOfChecked > 0);
            // 是否半选：children中可操作的数量不等于选中数量并且选中数大于0或者半选数大于0
            dataSource[index].indeterminate =
                numberOfActiveItem !== numberOfChecked &&
                    (numberOfChecked > 0 || numberOfIndeterminate > 0);
            // dataSource[index].indeterminate =
            //   !selectedKeys.includes(key) && (numberOfChecked > 0 || numberOfIndeterminate > 0);
        }
        else {
            dataSource[index].isSelected = selectedKeys.includes(key);
        }
    });
};
exports.checkSelectStatus = checkSelectStatus;
var cloneDeep = function (obj) {
    if (obj instanceof Date) {
        return new Date(obj);
    }
    if (obj instanceof RegExp) {
        return new RegExp(obj);
    }
    if (typeof obj !== 'object') {
        return obj;
    }
    var cloneObj = new obj.constructor();
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            cloneObj[key] = (0, exports.cloneDeep)(obj[key]);
        }
    }
    return cloneObj;
};
exports.cloneDeep = cloneDeep;
var generateMap = function (dataSource) {
    var map = {};
    function loop(list) {
        list === null || list === void 0 ? void 0 : list.forEach(function (item) {
            map[item.key] = item;
            loop(item.children);
        });
    }
    loop(dataSource);
    return map;
};
exports.generateMap = generateMap;
// 广度优先遍历查询数据的最大深度
var getDataDepth = function (dataSource) {
    if (!dataSource || dataSource.length === 0) {
        return 0;
    }
    var queue = [];
    var height = 0;
    queue.push.apply(queue, tslib_1.__spreadArray([], tslib_1.__read(dataSource), false));
    while (queue.length) {
        var length_1 = queue.length;
        for (var i = 0; i < length_1; i++) {
            var temp = queue.shift();
            if (temp.children) {
                queue.push.apply(queue, tslib_1.__spreadArray([], tslib_1.__read(temp.children), false));
            }
        }
        height++;
    }
    return height;
};
exports.getDataDepth = getDataDepth;
//# sourceMappingURL=utils.js.map